import { topicItems } from '@/mocks/homeData';

const colorMap: Record<string, { bg: string; text: string; bgHover: string }> = {
  primary: {
    bg: 'bg-primary-100',
    text: 'text-primary-700',
    bgHover: 'hover:bg-primary-200',
  },
  accent: {
    bg: 'bg-accent-100',
    text: 'text-accent-800',
    bgHover: 'hover:bg-accent-200',
  },
  secondary: {
    bg: 'bg-secondary-100',
    text: 'text-secondary-700',
    bgHover: 'hover:bg-secondary-200',
  },
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-5xl">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-3">
            话题标签
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            当前最热的黑料话题，点击探索你感兴趣的内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicItems.map((item) => {
            const colors = colorMap[item.color] || colorMap.secondary;
            return (
              <span
                key={item.id}
                className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full ${colors.bg} ${colors.text} text-sm font-medium ${colors.bgHover} transition-colors cursor-pointer`}
              >
                <span className="whitespace-nowrap">{item.name}</span>
                <span className="text-xs opacity-70 font-semibold">{item.heat}</span>
              </span>
            );
          })}
        </div>
      </div>
    </section>
  );
}